<pbc-sorter [config]="BesichtigungsStatiSorterConfig" [sorter]="besichtigungsStati.sorter$ | async" (sorterChange)="besichtigungsStati.sorter$.next($event)"></pbc-sorter>
